export const ERRORS = {
  genericMessage: "Oops algo deu errado.",
};
export const PET_CATEGORY_ID = "62179660df066feeb9b3967c";
export const FASHION_CATEGORY_ID = "6217965adf066feeb9b39679";
export const FOOD_CATEGORY_ID = "621794284b5d3840416cdbb4";
